import { render, staticRenderFns } from "./DockBottom.vue?vue&type=template&id=4b7fcdd2"
import script from "./DockBottom.vue?vue&type=script&lang=js"
export * from "./DockBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports